import { Button } from 'uikit'
import { filter } from 'lodash'
import { useMemo } from 'react'
import { SiSublimetext } from 'react-icons/si'
import { useHistory } from 'react-router-dom'
import { Snippets, SnippetsHeading, SnippetsItem, SnippetsList } from 'uikit'
import { HeadingItem, ItemIcon, ItemLink, ItemText } from 'uikit/Snippets'
import {
  Container,
  FilterHeader,
  SnippetsContainer,
  SnippetsContainerMain,
  SnippetsContainerRightAside,
} from 'uikit/layout'
import { useFetchReferralCatalog } from './services/useFetchReferralCatalog'

export const List = () => {
  const history = useHistory()
  const { data, isPending: isLoading } = useFetchReferralCatalog()

  const _data = useMemo(() => filter(data, (e) => !e?.hidden), [data])

  return (
    <Container>
      <SnippetsContainer indentTop={120}>
        <SnippetsContainerMain>
          <Snippets columns="42px minmax(400px, 1fr) 380px 380px 400px 400px" itemWidth="2200px">
            <SnippetsHeading>
              <HeadingItem />
              <HeadingItem>Код</HeadingItem>
              <HeadingItem>Описание</HeadingItem>
              <HeadingItem>Вознаграждение приглашенного</HeadingItem>
              <HeadingItem>Вознаграждение пригласившего</HeadingItem>
              <HeadingItem>Зависимость</HeadingItem>
            </SnippetsHeading>
            <SnippetsList
              activePage={0}
              totalPages={0}
              data={_data}
              keyField="eventCode"
              isLoading={isLoading}
            >
              {(item) => (
                <SnippetsItem to={`/referral/catalog/show/${item.eventCode}`}>
                  <ItemIcon IconComponent={SiSublimetext} />
                  <ItemLink>{item?.eventCode}</ItemLink>
                  <ItemText>{item?.description}</ItemText>
                  <ItemText>{`${item?.referralReward}`}</ItemText>
                  <ItemText>{`${item?.referrerReward}`}</ItemText>
                  <ItemText>{item?.relatedEvents}</ItemText>
                </SnippetsItem>
              )}
            </SnippetsList>
          </Snippets>
        </SnippetsContainerMain>
        <SnippetsContainerRightAside>
          <FilterHeader>
            <Button
              width="100%"
              onClick={() => history.push(`/referral/catalog/new`)}
              colorPalette="orange"
            >
              Создать
            </Button>
          </FilterHeader>
        </SnippetsContainerRightAside>
      </SnippetsContainer>
    </Container>
  )
}
